import React, { useRef } from 'react';
import { IHeaderParams } from 'ag-grid-community';

import { Checkbox } from '@/components/common/CheckboxTag4/CheckboxTag4';
import styles from './checkbox.module.scss';

export interface IBaseHeaderCheckboxProps {
  onChange: (params: IHeaderParams) => void;
  id?: string;
  checked?: boolean | null;
}

export interface BaseHeaderCheckboxProps extends IHeaderParams, IBaseHeaderCheckboxProps { }

export default function BaseHeaderCheckbox(params: BaseHeaderCheckboxProps) {
  const { onChange, id, checked } = params;
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={styles['header-checkbox']}
      onClick={() => checkboxRef.current?.click()}
    >
      <Checkbox
        ref={checkboxRef}
        id={id}
        onChange={() => onChange?.(params)}
        checked={checked}
        containerProps={{ className: styles['checkbox-container'] }}
      />
    </div>
  );
}
